module.exports = __webpack_public_path__ + "img/lineman_charge_logo.5e26b9c6.png";